'use strict'

require('./helpers/breakpoints')
require('./helpers/lazy-load')

require('./popups')

require('./global_events')

require('./setup')

require('./locomotive-scroll')
require('./cookies')

require('./sections/header')
require('./sections/navigation')
require('./sections/first')






